import { render, staticRenderFns } from "./LudomelixPage.vue?vue&type=template&id=58c4d534"
import script from "./LudomelixPage.vue?vue&type=script&lang=js"
export * from "./LudomelixPage.vue?vue&type=script&lang=js"
import style0 from "./lodomelix.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports